var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeaf = function SvgLeaf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h48v48H0z",
    "data-name": "invisible box"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7 36.9c-4.6-7.7-16-15.4-22.2-16.2a2 2 0 0 0-2.2 2.6 2 2 0 0 0 1.7 1.3c2.8.5 7.6 3 11.9 6.4-3.6 3.4-9 4.9-13.4 3.6-7.7-2.2-11.6-12.1-14.4-20.3l7.6-1.1c6.6-1.2 12.3-2.2 16.1.4s4 5 4.6 8.3l2.6 1.8a1 1 0 0 0 1.6-.9c-.6-4.7-2.1-9.4-6.5-12.4S21.2 8 14 9.2a81 81 0 0 1-9.7 1.3H3a.9.9 0 0 0-.9 1.3l.4 1.2c3.1 9.4 7.4 22.3 17.8 25.4a17.4 17.4 0 0 0 4.5.6A19.5 19.5 0 0 0 38 33.7a29.4 29.4 0 0 1 4.3 5.3 1.9 1.9 0 0 0 1.7 1 2.2 2.2 0 0 0 1.3-.4 2.1 2.1 0 0 0 .4-2.7",
    "data-name": "Q3 icons"
  }))));
};
export default SvgLeaf;